<!--
 * @Author: huanhaun
 * 首页课程item
-->
<template>
    <div class="item">
        <img :src="item.cover" alt="">
        <div>
            <p>{{item.category_name}}</p>
            <span>{{item.create_time}}</span>
            <div>
                <span>{{item.num}}</span>
                <div @click="onPressNav('courseDetail')">去报名</div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "homeCourseItem",
    props:['item'],
    data() {
        return {
            
        };
    },
    methods: {
        onPressNav(router, query={}) {
            this.$router.push({path: '/'+router, query: query})
        },
    },
    created() {
        console.log('this', this)
    },
};
</script>
<style lang="less" scoped>
.item {
    margin-top: 10px;
    display: flex;

    > img {
        width: 146px;
        height: 84px;
        margin-right: 10px;
    }

    > div {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        > p {
            font-size: 15px;
            color: #333;
            font-weight: 500;
        }

        > span {
            font-size: 13px;
            color: #333;
        }

        > div {
            display: flex;
            align-items: center;

            span {
                flex: 1;
                font-size: 13px;
                color: #333;
            }

            div {
                width: 50px;
                height: 20px;
                border-radius: 10px;
                border: 1px solid #7181EB;
                text-align: center;
                line-height: 20px;
                font-size: 12px;
                color: #7181EB;
            }
        }
    }
}
</style>